<template>
  <select style="width:100%"></select>
</template>

<script>
let processResults = function (data) {
  let results = data.results;
  let tmp_data = [];
  let tmp_data_city = [];

  _.sortBy(results, 'description').forEach(function (data, idx) {
    if (data) {
      tmp_data_city.push({
        id: data.place_id,
        text: data.description,
        value: data.description,
        el: data
      });
    }
  });

  if(tmp_data_city.length){
    tmp_data.push({
      text: "Cidade, Estado",
      children: tmp_data_city
    });
  }
  return {
    results: tmp_data
  };
};

import _ from "underscore";

export default {
  props: ["value", "dataInitial"],
  data() {
    return {
      content: this.value,
      grouped_by_city: []
    };
  },
  watch: {
    dataInitial: function () {
      this.setSelect();
    },
    value: {
      handler(newVal) {
        this.content = newVal;
        this.$nextTick(() => this.applyCurrentValue());
      },
      deep: true
    }
  },
  methods: {
    changeHandle(e) {
      this.$emit("input", this.content);
    },
    applyCurrentValue() {
      const destination = $(this.$el);
      const current = this.content || this.value;
      if (!current || !current.id) return;
      const text = current.text || current.value || "";
      const option = new Option(text, current.id, true, true);
      const exists = destination.find(`option[value='${current.id}']`).length > 0;
      if (!exists) destination.append(option);
      destination.val(current.id).trigger("change");
    },
    setSelect() {
      let destination = $(this.$el);
      this.$nextTick(function () {
        let opt = {
          language: "pt-BR",
          minimumInputLength: 3,
          debug: true,
          placeholder: "Endereço ou cidade e bairro",
          ajax: {
            quietMillis: 400,
            delay: 250,
            url: "/api/vehicle/autocomplete/",
            processResults: processResults,
            dataType: "json"
          }
        };
        if (this.dataInitial) {
          opt = _.extend(opt, {data: JSON.parse(JSON.stringify(this.dataInitial))});
        }

        destination.select2(opt);

        destination.on("select2:select", e => {
          this.content = e.params.data;
          this.changeHandle(e);
          this.dataInitial = false;
        });
        this.applyCurrentValue();
      });
    }
  },
  mounted() {
    this.setSelect();
  }
};
</script>

<style>
</style>

